// js/modules/country-select/populate.ts

import { REGIONS, Country } from './data';
import { activateFloatingLabel } from '../utils';

export const populateRegions = (
  form: HTMLFormElement,
  country: Country,
  selected?: string
) => {
  const select = form.querySelector<HTMLSelectElement>(
    'select[name="province"]'
  );
  if (!select) {
    return;
  }

  select.innerHTML = '<option value=""></option>';

  const regions: readonly string[] = REGIONS[country] ?? REGIONS.Canada;
  regions.forEach((region) => {
    const option = document.createElement('option');
    option.value = region;
    option.textContent = region;

    if (selected === region) {
      option.selected = true;
    }

    select.appendChild(option);
  });

  activateFloatingLabel(select);
};
